<template>
  <div class="row">
    <div class="col-sm-3" v-for="item in items" :key="item.name">
      <div class="card card-document" @click="show(item)">
        <div class="card-body text-center">
          <strong>
            <small>{{ item.name }}</small>
          </strong>
        </div>
      </div>
    </div>
    <hr>

    <ShowDataModal v-model="showModal" :header="currentItem.name" :data="currentItem" :deep="3" />
  </div>
</template>

<script>
import ShowDataModal from '@/components/admin/ShowDataModal'

export default {
  components: { ShowDataModal,  },
  created() {
    this.find()
  },
  data() {
    return {
      currentItem: {},
      items: [],
      showModal: false
    }
  },
  methods: {
    find() {
      this.axios.v3.get('documentations/items')
        .then(response => this.items = response.data)
    },
    show(item) {
      this.currentItem = item
      this.showModal = true
    }
  },
  name: 'AdminDocumatationItems'
}
</script>

<style scoped>
.card-body {
  cursor: pointer;
}
</style>
